import { render, staticRenderFns } from "./TextIcon.vue?vue&type=template&id=f478ae9c&scoped=true"
import script from "./TextIcon.vue?vue&type=script&lang=js"
export * from "./TextIcon.vue?vue&type=script&lang=js"
import style0 from "./TextIcon.vue?vue&type=style&index=0&id=f478ae9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f478ae9c",
  null
  
)

export default component.exports